// extracted by mini-css-extract-plugin
export default {"link":"link___tZXAa","phoneNumber":"phoneNumber___dgxIA"};